import {
  CheckIcon,
  ChevronDownIcon,
  FilterIcon
} from '@heroicons/react/outline';
import { Fragment, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';

import classNames from 'classnames';

const filters = [
  { name: 'Tất cả', value: null },
  { name: 'Đang giảm giá', value: { onSale: 'true' } }
];

export default function FilterSelect({
  className,
  value,
  onChange,
  options = []
}) {
  const [filterOptions] = useState(options.length > 0 ? options : filters);
  return (
    <Listbox
      value={value}
      onChange={onChange}
      className={classNames('ml-auto w-[50%] text-sm', className)}
    >
      <div className="relative mt-1">
        <Listbox.Button className="input relative w-full cursor-default bg-white pl-2 pr-10 text-left focus:outline-none focus-visible:outline-none sm:text-sm">
          <span className="flex items-center truncate">
            <FilterIcon className="mr-2 h-5 w-5 stroke-1" />
            {value ? value.name : 'Lọc'}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-gray-400" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options
            className="absolute mt-1 block max-h-60 w-[50%] overflow-auto
                                        bg-white py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          >
            {filterOptions.map((elem, index) => (
              <Listbox.Option
                key={index}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pr-4 pl-8 text-sm last:border-0 ${
                    active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'
                  }`
                }
                value={elem}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={`block truncate ${
                        selected ? 'font-medium' : 'font-normal'
                      }`}
                    >
                      {elem.name}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-amber-600">
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
    // </div>
  );
}
